<template>
  <v-container fluid class="pa-4">
    <!-- HEADER -->
    <v-row class="mb-3">
      <v-col cols="12">
        <div class="d-flex align-center justify-space-between">
          <div>
            <h3 class="mb-1">Document Management</h3>
            <div class="text-caption text-grey">
              Project Documents / CMS
            </div>
          </div>

          <div class="d-flex gap-2">
            <v-btn color="primary" @click="openCreateFolder">
              <v-icon start>mdi-folder-plus</v-icon>
              New Folder
            </v-btn>

            <v-btn color="primary" variant="tonal" @click="openDocumentModal">
              <v-icon start>mdi-cloud-upload</v-icon>
                Upload Document
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- MAIN LAYOUT -->
    <v-row>
      <!-- LEFT: FOLDER TREE -->
      <v-col cols="12" md="3">
        <FolderTree
          ref="folderTree"
          @select="onFolderSelect"
          @rename="openRenameFolder"
        />
      </v-col>

      <!-- RIGHT: DOCUMENT TABLE -->
      <v-col cols="12" md="9">
        <DocumentTable
          :folder-id="activeFolderId"
          :folder-name="activeFolderName"
          @view="openDocument"
          @new-version="openNewVersion"
        />
      </v-col>
    </v-row>

    <!-- CREATE / RENAME FOLDER DIALOG -->
    <FolderFormDialog
      v-model="folderDialog"
      :folder="editingFolder"
      :parent-id="activeFolderId"
      @saved="reloadFolders"
    />

    <cmsFolderModal
      v-model:dialog="folderModalOpen"
      :folder-data="selectedFolder"
      :is-edit-mode="isEditMode"
      :folders-list="folderList"
      @refresh="fetchFolders"
      @update:dialog="folderModalOpen = $event"
    />

    <cmsDocumentUploadModal
      v-model:dialog="documentModalOpen"
      :document-data="selectedDocument"
      :is-edit-mode="isEditMode"
      @update:dialog="documentModalOpen = $event"
    />
  </v-container>
  
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { toast } from 'vue3-toastify'
import FolderTree from '@/components/module/cms/folderManagement/folderTree.vue'
import DocumentTable from '@/components/module/cms/documentManagement/documentTable.vue'
import FolderFormDialog from '@/components/module/cms/folderManagement/folderFormDialog.vue'
import cmsFolderModal from '@/components/module/cms/folderManagement/cmsFolderModal.vue'
import cmsDocumentUploadModal from "@/components/module/cms/documentManagement/cmsDocumentUploadModal.vue";
import { prefix } from '@/store/api'

const getCmsFoldersList = prefix + 'cms/folders'

/* -----------------------------
   State
----------------------------- */
const folderList = ref([])
const activeFolderId = ref(null)
const activeFolderName = ref('All Documents')
const selectedFolder = ref(null)

const selectedDocument = ref(null)
const documentModalOpen = ref(false)

const folderDialog = ref(false)
const editingFolder = ref(null)

const folderModalOpen = ref(false)

const folderTree = ref(null)

const isEditMode = ref(false)

/* -----------------------------
   Folder Actions
----------------------------- */
const onFolderSelect = (folderId, folderName = '') => {
  activeFolderId.value = folderId
  activeFolderName.value = folderName
}

const openCreateFolder = () => {
  fetchFolders()
  editingFolder.value = null
  // folderDialog.value = true
  folderModalOpen.value = true;
}

const openRenameFolder = folder => {
  editingFolder.value = folder
  folderDialog.value = true
}

const openDocumentModal = () => {
  selectedDocument.value = null;
  isEditMode.value = false;
  documentModalOpen.value = true;
}

const reloadFolders = () => {
  folderTree.value?.reload()
}

/* -----------------------------
   Document Actions
----------------------------- */

const fetchFolders = () => {
    axios.get(getCmsFoldersList, { params: { all: true } })
      .then((response) => {
        if (response.data.success) {
          folderList.value = response.data.data || [];
        } else {
          toast.error("Failed to fetch folders");
          folderList.value = [];
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Error fetching folders");
        folderList.value = [];
      })
  }

const openDocument = doc => {
  console.log('View document', doc)
  // open view modal later
}

const openNewVersion = doc => {
  console.log('New version', doc)
  // open version modal later
}
</script>
